var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 31,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M30.919 14.684a12.591 12.591 0 0 0-3.792-9.546C24.34 2.4 20.603 1.17 16.96 1.442",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.093 14.539a8.876 8.876 0 0 0-2.67-6.746c-2.07-2.031-4.882-2.887-7.578-2.568",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.298 12.703c.79 3.403 4.123 7.147 7.881 10.836 3.758 3.69 10.81 6.056 13.77 6.056 2.96 0 4.931-2.041 5.607-2.701.675-.66 1.003-2.62 1.003-3.418 0-.799-.54-.992-.54-.992s-4.611-2.257-5.677-2.734c-1.065-.476-1.707.335-1.707.335s-1.998 2.45-2.364 2.812c-.368.362-.948.283-.948.283s-4.044-1.474-6.15-3.544c-2.11-2.068-3.129-3.68-3.786-4.558-.657-.877 0-1.703 0-1.703s1.182-1.16 1.707-1.959c.525-.799.185-1.624.185-1.624S9.283 4.993 8.835 4.167c-.446-.826-2.103-.826-3.39-.67-1.286.155-2.864 2.864-2.864 2.864-.97 1.402-1.075 2.942-.289 6.348l.006-.006Z",
  stroke: "#fff",
  strokeWidth: 2,
  strokeMiterlimit: 10
})));
export { SvgPhone as ReactComponent };
export default __webpack_public_path__ + "/assets/555db8a0a4fd507ebac6fdb89c9dec4b.svg";